import React from 'react';
import { Col } from 'react-bootstrap';
import ExternalImage from './ExternalImage';

const Thumbnails = ({ onClick, media, productName }) => {
  if (!media || !media.length) return null;

  return media.map((mediaItem, index) => (
    <Col
      key={`thumbnail-image-${mediaItem.url}`}
      onClick={() => onClick(mediaItem.url, index)}
      xs={4}
      sm={4}
      md={4}
      lg={4}
    >
      <ExternalImage
        src={mediaItem.url}
        key={mediaItem.url}
        width={200}
        height={200}
        alt={
          mediaItem.altTag !== 'NONE'
            ? `Thumbnail showing ${mediaItem.altTag}`
            : `${productName} example thumbnail ${index + 1}`
        }
      />
    </Col>
  ));
};

export default Thumbnails;
